import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const ProCTA = () => {
  return (
    <section className="py-16 md:py-20 bg-[#37b34a]" id="join-pro">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 bg-white/20 text-white text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
              <Sparkles size={14} />
              Early Access Open
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-3">
              Register now for early access
            </h2>
            <p className="text-white/90 text-base md:text-lg max-w-lg">
              Whether you're a professional looking for clients or searching for quality services — 
              sign up today and be first in line.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="/register"
              className="bg-white hover:bg-gray-50 text-[#37b34a] font-bold px-8 py-4 rounded-full text-base flex items-center justify-center gap-2 transition-colors duration-200 shadow-lg hover:shadow-xl no-underline"
            >
              I'm a Professional
              <ArrowRight size={18} />
            </a>
            <a
              href="/register"
              className="bg-white/20 hover:bg-white/30 text-white font-bold px-8 py-4 rounded-full text-base flex items-center justify-center gap-2 transition-colors duration-200 border border-white/30 no-underline"
            >
              I need a service
            </a>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          {[
            { value: '100+', label: 'Service categories' },
            { value: 'Free', label: 'To register' },
            { value: 'SA-Wide', label: 'Nationwide reach' },
            { value: '24/7', label: 'Available always' }
          ].map((stat, idx) => (
            <div key={idx} className="text-center">
              <div className="text-white text-2xl md:text-3xl font-extrabold mb-1">
                {stat.value}
              </div>
              <div className="text-white/80 text-sm">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProCTA;
